/**
 * Bouwt de publieke URL van een geüpload bestand. De server serveert uploads
 * statisch op /uploads (en /company-photos, /profile-photos), niet onder /api.
 * Opgeslagen waarden zijn een bestandsnaam of relatief pad (bijv.
 * "company-photos/x.png"); absolute paden en volledige URL's blijven staan.
 */
export const uploadUrl = (p: string): string =>
  p.startsWith('http') || p.startsWith('/') ? p : `/uploads/${p}`;
